module.exports = __webpack_public_path__ + "522d151e.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/new/design.png
// module id = 697
// module chunks = 1